import { makeNavCategoryId } from '../../state/closedNavCategories';

export const RECENTLY_OPENED_NAV_CATEGORY_ID = makeNavCategoryId('mindroom', 'recently-opened');
